export enum AppRoute {
  DASHBOARD = 'dashboard',
  SERVICE_DEPLOYMENT_METHOD = 'service-deployment/method',
  WORKSPACE_CREATE = 'workspace/create',
  SETTINGS = 'settings',
  SETTINGS_WORKSPACE = 'settings/workspace',
  SETTINGS_WORKSPACE_MEMBERS = 'settings/workspace/members',
  SETTINGS_PROJECT = 'settings/project',
  SETTINGS_PROJECT_MEMBERS = 'settings/project/members',
  LOGOUT = 'logout',
}
